var render = function render(){var _vm=this,_c=_vm._self._c;return _c('launch-game',{attrs:{"games":_vm.games,"countries":_vm.countries,"loading-games":_vm.loadingGames,"loading-proxy-countires":_vm.loadingProxyCountries},on:{"project-selected":_vm.loadGames,"project-provider-selected":_vm.loadProxyCountries,"launch-game":_vm.onLaunchGame}})
}
var staticRenderFns = []

export { render, staticRenderFns }